import { sheetTypeEnum } from '../SheetCalculatorStore';

function minimumComposedSize(type, page) {
  if (!page || !page.width || !page.height) return null;
  switch(type) {
    case 'brochure':
      return {
        width: page.width * 2,
        height: page.height,
        horizontalBleed: 0,
        whitespace: {
          top: 5,
          bottom: 5,
          right: 5,
          left: 15
        }
      };
    default:
      return {
        width: page.width,
        height: page.height
      }
  }
}

function shuffleForHalfFold(pages) {
  const numberOfPages = pages.length;
  if (!numberOfPages || numberOfPages % 4 !== 0) return console.error('number of pages is wrong for halfFold');
  const numberOfGroups = numberOfPages / 4;

  const result = [];

  for (let i = 0; i < numberOfGroups; i++) {
    const firstPage = i * 2;
    const lastPage = numberOfPages - 1 - (i * 2);
    result.push({
      width: 0,
      height: 0,
      top: 5,
      bottom: 5,
      right: 5,
      left: 15,


      front: [
        pages[lastPage],
        pages[firstPage]
      ],
      back: [
        pages[firstPage + 1],
        pages[lastPage - 1]
      ]
    })
  }

  console.log(JSON.stringify(result));

  return result;
}

// container = {width: number, height: number, type: sheetTypeEnum}
// bleeds = {horizontal: number || [numbers], vertical: number || [numbers]}
// size = {width: number, height: number}
function fits(container, bleeds, size) {
  const workAndTurn = container.type === sheetTypeEnum.WORK_AND_TURN;
  const workAndTumble = container.type === sheetTypeEnum.WORK_AND_TUMBLE;
  const minimumComposedSize = minimumComposedSize('brochure', size);
  const upright = {
    horizontal: fitsAxis(container.width)
  }
}

function fitsAxis(containerWidth, pageWidth, bleeds, shouldBeEven) {
  if (pageWidth > containerWidth) return 0;
  let currentBleed = typeof bleeds === 'number' ? bleeds : 0;
  let currentWidth = pageWidth;
  let i = 1;
  while (currentWidth <= containerWidth) {
    if (Array.isArray(bleeds)) currentBleed = bleeds[i - 1] || 0;

    currentWidth += pageWidth + bleeds[bleedIndex];
    if (currentWidth <= sheetWidth) i++;
  }
  if (shouldBeEven && (i % 2 !== 0)) return i - 1;
  return i;
}


/*
@computed get fits() {
  let workAndTurn = this.store.options.type === sheetTypeEnum.WORK_AND_TURN;
  let workAndTumble = this.store.options.type === sheetTypeEnum.WORK_AND_TUMBLE;
  const upright = {
    horizontal: this.fitsAxis(this.sheet.printable.width, this.page.width, this.bleed.asArray.horizontal, workAndTurn),
    vertical: this.fitsAxis(this.sheet.printable.height, this.page.height, this.bleed.asArray.vertical, workAndTumble)
  };
  const rotated = {
    horizontal: this.fitsAxis(this.sheet.printable.width, this.page.height, this.bleed.asArray.horizontal, workAndTurn),
    vertical: this.fitsAxis(this.sheet.printable.height, this.page.width, this.bleed.asArray.vertical, workAndTumble)
  };
  if (upright.horizontal * upright.vertical >= rotated.horizontal * rotated.vertical) {
    return {
      type: 'upright',
      horizontal: upright.horizontal,
      vertical: upright.vertical,
      total: upright.horizontal * upright.vertical
    };
  } else {
    return {
      type: 'rotated',
      horizontal: rotated.horizontal,
      vertical: rotated.vertical,
      total: rotated.horizontal * rotated.vertical
    };
  }
}
*/


// WEBPACK FOOTER //
// ./src/views/SheetCalculator/Components/Imposition.js